var _circle, _g, _g2, _g3, _g4, _g5, _g6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPearl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.559,
    cy: 10.8168,
    r: 10.3776,
    transform: "rotate(-180 11.559 10.8168)",
    fill: "#DBC7BC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2014_49270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.3787 12.1051C3.3787 12.1051 3.3787 9.74518 11.5344 9.74518C17.6939 9.74518 19.1882 11.4166 19.507 11.9462C19.5679 12.0472 19.5864 12.1648 19.5826 12.2827C19.4737 15.6777 16.2615 19.4692 11.5344 19.4692C6.72461 19.4692 3.37869 15.5441 3.3787 12.1051Z",
    fill: "#AFADB2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2014_49270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4364 7.231C20.932 8.14332 19.9498 8.86702 19.0278 8.38948C12.8011 5.16412 7.33038 6.44434 1.5708 10.1602C1.5708 10.1602 3.16534 2.31934 11.6347 2.31934C16.7558 2.31934 19.2582 5.06225 20.4364 7.231Z",
    fill: "#ECE6D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2014_49270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4462 5.63969C18.9304 1.46973 8.14757 -1.33463 3.1416 4.96001C3.1416 4.96001 6.09881 0.202445 11.9769 0.490075C17.855 0.777704 20.4462 5.63969 20.4462 5.63969Z",
    fill: "#CA9D97",
    fillOpacity: 0.12
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_2014_49270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.01009 11.2417C7.97205 10.7922 8.23471 10.3729 8.6605 10.2239C10.6365 9.53266 13.2876 9.56186 14.9844 10.5046C14.9844 10.5046 14.0989 15.9673 11.6249 15.9673C9.38352 15.9673 8.21087 13.6142 8.01009 11.2417Z",
    fill: "#82837D"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_2014_49270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5344 19.3909C6.76646 19.3909 3.45699 15.4995 3.45699 12.1051L3.45711 12.1027C3.45728 12.0997 3.45765 12.0946 3.45846 12.0876C3.46009 12.0734 3.4635 12.0514 3.47063 12.0225C3.48488 11.9648 3.51406 11.8795 3.57397 11.7755C3.69355 11.5678 3.93769 11.2821 4.43737 10.9929C5.4391 10.4132 7.46151 9.82348 11.5344 9.82348C17.6832 9.82348 19.1422 11.492 19.44 11.9866C19.4904 12.0704 19.5078 12.1714 19.5043 12.2802C19.3968 15.6335 16.2188 19.3909 11.5344 19.3909Z",
    stroke: "#CA9D97",
    strokeWidth: 0.156583
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_2014_49270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.43001 16.4894C4.33532 15.0133 5.80898 13.4117 7.64665 13.4117L15.4734 13.4117C17.3111 13.4117 18.793 15.0129 17.7115 16.4987C16.4945 18.1705 14.3325 19.4692 11.6067 19.4692C8.87591 19.4692 6.67319 18.1656 5.43001 16.4894Z",
    fill: "#FFFFFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2014_49270",
    x: 1.81308,
    y: 8.17929,
    width: 19.3358,
    height: 12.8558,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.782915,
    result: "effect1_foregroundBlur_2014_49270"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2014_49270",
    x: 0.00497162,
    y: 0.753507,
    width: 22.1302,
    height: 10.9725,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.782915,
    result: "effect1_foregroundBlur_2014_49270"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2014_49270",
    x: 2.82844,
    y: 0.164373,
    width: 17.931,
    height: 5.78844,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.156583,
    result: "effect1_foregroundBlur_2014_49270"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2014_49270",
    x: 6.5971,
    y: 8.33685,
    width: 9.79652,
    height: 9.03968,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.704623,
    result: "effect1_foregroundBlur_2014_49270"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_2014_49270",
    x: 2.36112,
    y: 8.72733,
    width: 18.2397,
    height: 11.7597,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.508894,
    result: "effect1_foregroundBlur_2014_49270"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_2014_49270",
    x: 3.48935,
    y: 11.8458,
    width: 16.1546,
    height: 9.18928,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.782915,
    result: "effect1_foregroundBlur_2014_49270"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPearl);
export default __webpack_public_path__ + "static/media/pearl.2bc9752fdfb5300489b1c2b962310ee1.svg";
export { ForwardRef as ReactComponent };